export default __webpack_public_path__ + "static/media/knowledge.0d549ebe.svg";